import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { LogOut, Home, BookOpen, User, Sparkles } from "lucide-react";
import { NavLink } from "./NavLink";
import MobileBottomNav from "./MobileBottomNav";

const Navbar = () => {
  const navigate = useNavigate();
  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate("/auth");
  };
  return (
    <>
      <header className="border-b border-border bg-card shadow-sm sticky top-0 z-10">
        <div className="container mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2 md:gap-3 animate-fade-in cursor-pointer group" onClick={() => navigate("/home")}>
              <div className="w-10 h-10 bg-gradient-to-br from-[hsl(var(--playful-orange))] to-[hsl(var(--playful-pink))] rounded-xl flex items-center justify-center shadow-md group-hover:scale-105 transition-transform">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <span className="font-display text-xl font-bold bg-gradient-to-r from-[hsl(var(--playful-orange))] to-[hsl(var(--playful-pink))] bg-clip-text text-transparent">
                StoryPlay
              </span>
            </div>
            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-1">
              <NavLink to="/home" className="flex items-center gap-2 px-3 py-2 rounded-lg text-foreground/70 hover:text-foreground hover:bg-accent transition-colors" activeClassName="font-semibold text-foreground bg-accent/50 pointer-events-none">
                <Home className="w-4 h-4" />
                Home
              </NavLink>
              <NavLink to="/library" className="flex items-center gap-2 px-3 py-2 rounded-lg text-foreground/70 hover:text-foreground hover:bg-accent transition-colors" activeClassName="font-semibold text-foreground bg-accent/50 pointer-events-none">
                <BookOpen className="w-4 h-4" />
                Library
              </NavLink>
              <NavLink to="/account" className="flex items-center gap-2 px-3 py-2 rounded-lg text-foreground/70 hover:text-foreground hover:bg-accent transition-colors" activeClassName="font-semibold text-foreground bg-accent/50 pointer-events-none">
                <User className="w-4 h-4" />
                Account
              </NavLink>
            </nav>
          </div>
          <Button variant="outline" size="sm" onClick={handleSignOut} className="gap-2">
            <LogOut className="w-4 h-4" />
            <span className="hidden sm:inline">Sign Out</span>
          </Button>
        </div>
      </header>
      {/* Mobile Bottom Navigation */}
      <MobileBottomNav />
    </>
  );
};
export default Navbar;